export { default } from './JoinQr';



// WEBPACK FOOTER //
// ./src/components/templates/JoinQr/index.js